export type SportLike = string;

/**
 * Runtime-agnostic YouTube search URL generator.
 * This module is safe to import from both the frontend (Vite) and Edge Functions (Deno).
 */
export function createYoutubeSearchUrl(stepName: string, sport: SportLike, positionGroup?: string): string {
  // Ensure we use "tackle football" explicitly instead of just "Football"
  const sportTerm = sport === 'Football' ? 'tackle football' : sport;

  // Include position group in the search query if available
  const positionGroupTerm = positionGroup && positionGroup !== 'ALL' ? `${positionGroup}` : '';

  const searchQuery =
    `coaching ${sportTerm} drill ${stepName.trim()}` + (positionGroupTerm ? ` for ${positionGroupTerm}` : '');

  return `https://www.youtube.com/results?search_query=${encodeURIComponent(searchQuery)}`;
}

